import { translate } from "app/filters/i18nFilter";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import type SignalFiltersViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFiltersViewProps";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import SignalFiltersViewHeader from "../../../shared/SignalFiltersViewHeader/SignalFiltersViewHeader";

type Props = Pick<SignalFiltersViewProps<SignalFilters>, "renderTemplateView"> & {
    onTemplateSelect(template: Readonly<SignalTemplate<SignalFilters>>): void;
};

const DROPDOWN_WIDTH = 352;
const DROPDOWN_HEIGHT = 300;

const EcommerceSignalFiltersViewHeader = (props: Props) => {
    return (
        <SignalFiltersViewHeader text={translate(signalsI18nKeys.managementLabel.ecommerce)}>
            {props.renderTemplateView({
                dropdownPopupWidth: DROPDOWN_WIDTH,
                dropdownPopupHeight: DROPDOWN_HEIGHT,
                hideTemplateDescriptionTooltip: true,
                onSelect: props.onTemplateSelect,
            })}
        </SignalFiltersViewHeader>
    );
};

export default EcommerceSignalFiltersViewHeader;
